import { render, staticRenderFns } from "./SettlementsPerDay.vue?vue&type=template&id=ac81f898"
import script from "./SettlementsPerDay.vue?vue&type=script&lang=ts"
export * from "./SettlementsPerDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports